import { AssetSelectionGrid } from '@client/components/ltc-financial-planning/AssetSelectionGrid';
import { StepContentProps } from '../types';

export function AssetsStep({ navigation }: StepContentProps) {
  return (
    <div className="py-8 text-center">
      <h1 className="text-2xl font-bold text-gray-900 md:text-3xl">What assets do you have?</h1>
      <p className="mx-auto mt-3 max-w-2xl text-base text-gray-700">
        Select all the accounts and assets you currently own. We'll use this to assess your
        long-term care coverage capacity.
      </p>
      <AssetSelectionGrid className="mx-auto mt-8 max-w-3xl" />
    </div>
  );
}
